import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "gfu-blog__item" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 0,
  class: "gfu-blog__date"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 1,
  class: "_flexwrap _gap-1"
}
const _hoisted_6 = { class: "gfu-blog__description" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "gfu-link-underline__content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_blog_post_restricted_visibility = _resolveComponent("blog-post-restricted-visibility")
  const _component_base_heading = _resolveComponent("base-heading")
  const _component_base_tag = _resolveComponent("base-tag")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_content_renderer = _resolveComponent("content-renderer")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_heading, {
      divider: "left",
      variant: "decorative",
      tag: "h1",
      class: "_flex _gap-1"
    }, {
      default: _withCtx(() => [
        ($props.blogPost.canEdit)
          ? (_openBlock(), _createBlock(_component_blog_post_restricted_visibility, {
              key: 0,
              "is-unpublish": !$props.blogPost.isPublished
            }, null, 8 /* PROPS */, ["is-unpublish"]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("a", {
          class: _normalizeClass(`gfu-link gfu-link--nofx gfu-link--block gfu-link--inline ${$options.linkDisabledClass}`),
          href: $options.blogPostUrl
        }, _toDisplayString($props.blogPost.title), 11 /* TEXT, CLASS, PROPS */, _hoisted_2)
      ]),
      _: 1 /* STABLE */
    }),
    ($props.blogPost.publishDate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("a", {
            class: _normalizeClass(`gfu-link gfu-link--nofx gfu-link--block gfu-link--inline ${$options.linkDisabledClass}`),
            href: $options.blogPostUrl
          }, _toDisplayString($options.formattedPublishDate), 11 /* TEXT, CLASS, PROPS */, _hoisted_4)
        ]))
      : _createCommentVNode("v-if", true),
    ($props.blogPost.tagNames && $props.blogPost.tagNames.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.blogPost.tagNames, (tagName) => {
            return (_openBlock(), _createBlock(_component_base_tag, { key: tagName }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(tagName), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_6, [
      ($props.isPreview)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "gfu-link gfu-link--nofx gfu-link--block gfu-link--inline",
            href: $options.blogPostUrl
          }, _toDisplayString($props.blogPost.description), 9 /* TEXT, PROPS */, _hoisted_7))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString($props.blogPost.description), 1 /* TEXT */)
          ], 64 /* STABLE_FRAGMENT */))
    ]),
    ($props.isPreview)
      ? (_openBlock(), _createElementBlock("a", {
          key: 2,
          class: "_tc--accent gfu-link-underline",
          href: $options.blogPostUrl
        }, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.Resources.Common.ReadMoreActionButton), 1 /* TEXT */),
          _createVNode(_component_base_icon, {
            name: "chevron-right",
            size: "sm"
          })
        ], 8 /* PROPS */, _hoisted_8))
      : (_openBlock(), _createBlock(_component_content_renderer, {
          key: 3,
          class: "gfu-blog__content",
          content: $props.blogPost.content
        }, null, 8 /* PROPS */, ["content"]))
  ]))
}